/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_newsletter_subscription_failure_already_subscribed = /** @type {(inputs: {}) => string} */ () => {
	return `Tato e-mailová adresa je již zaregistrována k odběru newsletteru.`
};

const da_newsletter_subscription_failure_already_subscribed = /** @type {(inputs: {}) => string} */ () => {
	return `Denne e-mailadresse er allerede tilmeldt nyhedsbrevet.`
};

const de_newsletter_subscription_failure_already_subscribed = /** @type {(inputs: {}) => string} */ () => {
	return `Diese E-Mail-Adresse ist bereits für den Newsletter registriert.`
};

const en_newsletter_subscription_failure_already_subscribed = /** @type {(inputs: {}) => string} */ () => {
	return `This email address is already subscribed to the newsletter.`
};

const es_newsletter_subscription_failure_already_subscribed = /** @type {(inputs: {}) => string} */ () => {
	return `Esta dirección de correo ya está suscrita al boletín.`
};

const fr_newsletter_subscription_failure_already_subscribed = /** @type {(inputs: {}) => string} */ () => {
	return `Cette adresse email est déjà inscrite à la newsletter.`
};

const hu_newsletter_subscription_failure_already_subscribed = /** @type {(inputs: {}) => string} */ () => {
	return `Ez az e-mail cím már fel van iratkozva a hírlevélre.`
};

const it_newsletter_subscription_failure_already_subscribed = /** @type {(inputs: {}) => string} */ () => {
	return `Questo indirizzo e-mail è già iscritto alla newsletter.`
};

const nl_newsletter_subscription_failure_already_subscribed = /** @type {(inputs: {}) => string} */ () => {
	return `Dit e-mailadres is al ingeschreven voor de nieuwsbrief.`
};

const pl_newsletter_subscription_failure_already_subscribed = /** @type {(inputs: {}) => string} */ () => {
	return `Ten adres email jest już zapisany do newslettera.`
};

const pt_newsletter_subscription_failure_already_subscribed = /** @type {(inputs: {}) => string} */ () => {
	return `Este endereço de e-mail já está inscrito na newsletter.`
};

const sv_newsletter_subscription_failure_already_subscribed = /** @type {(inputs: {}) => string} */ () => {
	return `Denna e-postadress är redan registrerad för nyhetsbrevet.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const newsletter_subscription_failure_already_subscribed = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.newsletter_subscription_failure_already_subscribed(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("newsletter_subscription_failure_already_subscribed", locale)
	if (locale === "cs") return cs_newsletter_subscription_failure_already_subscribed(inputs)
	if (locale === "da") return da_newsletter_subscription_failure_already_subscribed(inputs)
	if (locale === "de") return de_newsletter_subscription_failure_already_subscribed(inputs)
	if (locale === "en") return en_newsletter_subscription_failure_already_subscribed(inputs)
	if (locale === "es") return es_newsletter_subscription_failure_already_subscribed(inputs)
	if (locale === "fr") return fr_newsletter_subscription_failure_already_subscribed(inputs)
	if (locale === "hu") return hu_newsletter_subscription_failure_already_subscribed(inputs)
	if (locale === "it") return it_newsletter_subscription_failure_already_subscribed(inputs)
	if (locale === "nl") return nl_newsletter_subscription_failure_already_subscribed(inputs)
	if (locale === "pl") return pl_newsletter_subscription_failure_already_subscribed(inputs)
	if (locale === "pt") return pt_newsletter_subscription_failure_already_subscribed(inputs)
	return sv_newsletter_subscription_failure_already_subscribed(inputs)
};
export { newsletter_subscription_failure_already_subscribed as "newsletter.subscription.failure.already_subscribed" }